import { Head } from '@playbooks/ui/components/head';

import type { RouteProps } from '../types';

export const Route = ({ name = 'Route', seo, className, children, ...props }: RouteProps) => {
	return (
		<div {...props} className={className}>
			{seo && <Head {...seo} />}
			{children}
		</div>
	);
};
